import ModuleCardWidget from "../singleton/module-card-widget";
import ModuleCardScheduler from "../singleton/module-card-scheduler";
import ModuleCardPlanning from "../singleton/module-card-planning";
import ModuleCardList from "../singleton/module-card-list";
import ModuleCardGraphic from "../singleton/module-card-graphic";
import ModuleCards from "../singleton/module-card";

export default {

    changeModule: ModuleCards.changeModule.bind(ModuleCards),

    delete: ModuleCards.delete.bind(ModuleCards),

    clone: ModuleCards.clone.bind(ModuleCards),

    getData: ModuleCards.getData.bind(ModuleCards),

    getAll: ModuleCards.getAll.bind(ModuleCards),

    List: {

        create: ModuleCardList.create.bind(ModuleCardList),

        update: ModuleCardList.update.bind(ModuleCardList)

    },

    Widget: {

        create: ModuleCardWidget.create.bind(ModuleCardWidget),

        update: ModuleCardWidget.update.bind(ModuleCardWidget)

    },

    Graphic: {

        create: ModuleCardGraphic.create.bind(ModuleCardGraphic),

        update: ModuleCardGraphic.update.bind(ModuleCardGraphic)

    },

    Planning: {

        create: ModuleCardPlanning.create.bind(ModuleCardPlanning),

        update: ModuleCardPlanning.update.bind(ModuleCardPlanning)

    },

    Scheduler: {

        create: ModuleCardScheduler.create.bind(ModuleCardScheduler),

        update: ModuleCardScheduler.update.bind(ModuleCardScheduler)

    }

}